import script from "./pathTester.vue?vue&type=script&setup=true&lang=ts"
export * from "./pathTester.vue?vue&type=script&setup=true&lang=ts"

import "./pathTester.vue?vue&type=style&index=0&id=6534d3df&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6534d3df"]])

export default __exports__